const DEVICE_ID_KEY = 'pgx-device-id';
const DEVICE_ID_PATTERN = /^[A-Za-z0-9._:-]{8,128}$/;

const fallbackId = (): string => {
  const bytes = new Uint8Array(16);
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
    crypto.getRandomValues(bytes);
  }
  return Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
};

export function getOrCreateDeviceId(): string {
  try {
    const existing = localStorage.getItem(DEVICE_ID_KEY);
    if (existing && DEVICE_ID_PATTERN.test(existing)) {
      return existing;
    }
    const created =
      typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
        ? crypto.randomUUID()
        : fallbackId();
    localStorage.setItem(DEVICE_ID_KEY, created);
    return created;
  } catch {
    return fallbackId();
  }
}
